<template>
    <div class="nav-item">
        <a :href="computedHref" class="nav-link" v-c:active="isActive" @click.prevent="handleClick" tabindex="-1">
            <icon v-if="icon" :name="icon" class="nav-icon"/>
            <div v-if="this.$slots.default || $scopedSlots.default || this.label !== ''" class="nav-label">
                <slot>{{ label }}</slot>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        mixins: [
            require('../mixins/linkMixin').default,
        ],

        props: {
            small: {type: Boolean, default: false},
        },
    };
</script>